//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import date from "@/config/yunDateCalculate.js";
import Model from "@/models/yunMobile";
import PayCommon from "./PayCommon";
import { Decimal } from "decimal.js";
export default {
  components: {
    PayCommon
  },
  data() {
    return {
      num: 1,
      inputName: "", //姓名
      inputPhone: "", //电话
      carTypeNmae: "", //车辆类型
      cycleUnit: "", //周期单位1：周 2：月 3：年，4：天
      endTime: "", //到期时间
      amount: "", //充值金额
      queryParams: this.$route.query,
      authCode: ""
    };
  },
  created() {
    if (this.$isWx) {
      let listData = JSON.parse(sessionStorage.getItem("scanCodeataList"));
      this.queryParams = listData;
    }
    this.carTypeNmae = this.queryParams.carTypeName;

    if (this.queryParams.zhouqiDanwei == 1) {
      this.cycleUnit = "周";
    } else if (this.queryParams.zhouqiDanwei == 2) {
      this.cycleUnit = "月";
    } else if (this.queryParams.zhouqiDanwei == 3) {
      this.cycleUnit = "年";
    } else if (this.queryParams.zhouqiDanwei == 4) {
      this.cycleUnit = "天";
    }

    this.endTime = date.GetDateDiff(
      this.queryParams.cardEndTime,
      this.num,
      this.queryParams.zhouqiDanwei,
      this.queryParams.chongzhiCycle
    );
    this.amount = new Decimal(this.queryParams.chargeMoney)
      .mul(new Decimal(this.num))
      .toString();
  },
  mounted() {
    if (this.$isZfb) {
      ap.getAuthCode(
        {
          appId: "2016060201473949",
          scopes: ["auth_user"]
        },
        res => {
          this.authCode = res.authCode;
        }
      );
    }
  },
  methods: {
    handleChange(value) {
      this.endTime = date.GetDateDiff(
        this.queryParams.cardEndTime,
        value,
        this.queryParams.zhouqiDanwei,
        this.queryParams.chongzhiCycle
      );

      this.amount = new Decimal(this.queryParams.chargeMoney)
        .mul(new Decimal(value))
        .toString();
    },
    pay() {
      this.openCard();
    },
    async openCard() {
      if (this.inputName == "") {
        return this.$layer.msg("请输入姓名");
      }
      if (
        !/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(
          this.inputPhone
        )
      ) {
        this.$layer.msg("请输入正确的手机号码!");
        return;
      }

      const { unique } = this.queryParams;

      let { data } = await Model.createOrder({
        unique,
        ownerName: this.inputName,
        ownerTel: this.inputPhone,
        recharegeMoney: this.amount,
        cardEndTime: this.endTime,
        recharegeNum: this.num
      });

      console.log("订单号", data);

      if (!data.success) {
        return this.$layer.msg(data.error);
      }
      let params = {
        orderNo: data.list,
        OrderAmount: this.amount,
        gsBh: this.queryParams.gsbh,
        xmBh: this.queryParams.xmbh,
        parkNo: this.queryParams.parkNo,
        tollPayRsq: "",
        notifyType: 5
      };

      if (this.$isWx) {
        params.pageType = "openCardDetails";
        params.pageUrl = location.href;
        params.zhifuFs = "weChat_jsApi";
        sessionStorage.setItem("wxPayParams", JSON.stringify(params));
        const baseUrl =
          location.protocol === "https:"
            ? "https://ycc-test-front.hnchxwl.com"
            : "http://dzbus.iot.xin";
        const payUrl =
          process.env.NODE_ENV == "production"
            ? baseUrl
            : "http://192.168.8.192:8080";
        var url =
          payUrl +
          "/mobile/yunMobile/confirmPay/666?params=" +
          JSON.stringify(params);

        console.log("跳转路径", url);
        if (location.assign) {
          location.assign(url);
        } else {
          window.open(url);
        }
        return;
        // this.$refs.payCommon.payByWx({
        //   params,
        //   fail: res => {
        //     this.$layer.msg(res.error);
        //   },
        //   paySuccess: res => {
        //     this.$layer.msg(
        //       "支付成功！支付后30分钟短信通知充值结果，请注意查收！也可以输入车牌查看是否续费成功"
        //     );
        //     this.$router.go(-1);
        //   },
        //   payFail: res => {
        //     this.$layer.msg("支付失败");
        //   }
        // });
      } else if (this.$isZfb) {
        params.code = this.authCode;
        params.zhifuFs = "alipay_scan";
        this.$refs.payCommon.payByZfb({
          params,
          success: res => {
            Model.testCallback();
          },
          fail: res => {
            this.$layer.msg(res.error);
          }
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/openCardDetails.vue